import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a480f3a2&"
import script from "@/js/app.js?vue&type=script&lang=js&"
export * from "@/js/app.js?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports